import React from 'react';

const Privacy = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <h1 className="text-center mb-5">Privacy Policy</h1>
          
          <div className="card shadow-sm">
            <div className="card-body p-5">
              <p className="text-muted mb-4">
                <strong>Last updated:</strong> {new Date().toLocaleDateString('en-GB')}
              </p>

              <section className="mb-5">
                <h2 className="h4 mb-3">1. Introduction</h2>
                <p>
                  Patricians s'engage à protéger votre vie privée et vos données personnelles. 
                  Cette politique de confidentialité explique comment nous collectons, utilisons, 
                  stockons et protégeons vos informations lorsque vous visitez notre site web 
                  ou utilisez nos services.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">2. Informations que nous collectons</h2>
                
                <h3 className="h5 mb-3">2.1 Informations que vous nous fournissez</h3>
                <ul>
                  <li>Nom et prénom</li>
                  <li>Adresse e-mail</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresse de livraison et de facturation</li>
                  <li>Informations de paiement (cryptées)</li>
                  <li>Préférences de communication</li>
                </ul>

                <h3 className="h5 mb-3">2.2 Informations collectées automatiquement</h3>
                <ul>
                  <li>Adresse IP</li>
                  <li>Type de navigateur et version</li>
                  <li>Pages visitées et durée de visite</li>
                  <li>Données de navigation et cookies</li>
                  <li>Informations sur votre appareil</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">3. Utilisation de vos données</h2>
                <p>Nous utilisons vos données personnelles pour :</p>
                <ul>
                  <li>Traiter et expédier vos commandes</li>
                  <li>Vous fournir un service client de qualité</li>
                  <li>Personnaliser votre expérience d'achat</li>
                  <li>Vous envoyer des communications marketing (avec votre consentement)</li>
                  <li>Améliorer notre site web et nos services</li>
                  <li>Respecter nos obligations légales</li>
                  <li>Prévenir la fraude et assurer la sécurité</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">4. Partage de vos données</h2>
                <p>
                  Nous ne vendons jamais vos données personnelles. Nous pouvons partager 
                  vos informations uniquement dans les cas suivants :
                </p>
                <ul>
                  <li>Avec nos prestataires de services (transporteurs, processeurs de paiement)</li>
                  <li>Pour respecter une obligation légale</li>
                  <li>Pour protéger nos droits et notre sécurité</li>
                  <li>Avec votre consentement explicite</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">5. Cookies et technologies similaires</h2>
                <p>
                  Notre site utilise des cookies pour améliorer votre expérience. 
                  Vous pouvez contrôler l'utilisation des cookies via les paramètres 
                  de votre navigateur.
                </p>
                <h3 className="h5 mb-3">Types de cookies utilisés :</h3>
                <ul>
                  <li><strong>Cookies essentiels :</strong> Nécessaires au fonctionnement du site</li>
                  <li><strong>Cookies de performance :</strong> Nous aident à comprendre l'utilisation du site</li>
                  <li><strong>Cookies de fonctionnalité :</strong> Améliorent votre expérience</li>
                  <li><strong>Cookies marketing :</strong> Utilisés pour la publicité ciblée</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">6. Sécurité de vos données</h2>
                <p>
                  Nous mettons en place des mesures de sécurité appropriées pour protéger 
                  vos données personnelles contre l'accès non autorisé, la modification, 
                  la divulgation ou la destruction. Cela inclut :
                </p>
                <ul>
                  <li>Chiffrement SSL/TLS pour les transmissions</li>
                  <li>Accès restreint aux données personnelles</li>
                  <li>Surveillance régulière de nos systèmes</li>
                  <li>Formation de notre personnel sur la protection des données</li>
                </ul>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">7. Vos droits</h2>
                <p>Conformément au RGPD, vous avez le droit de :</p>
                <ul>
                  <li><strong>Accès :</strong> Demander une copie de vos données</li>
                  <li><strong>Rectification :</strong> Corriger des données inexactes</li>
                  <li><strong>Effacement :</strong> Demander la suppression de vos données</li>
                  <li><strong>Limitation :</strong> Restreindre le traitement de vos données</li>
                  <li><strong>Portabilité :</strong> Récupérer vos données dans un format structuré</li>
                  <li><strong>Opposition :</strong> Vous opposer au traitement de vos données</li>
                </ul>
                <p className="mt-3">
                  Pour exercer ces droits, contactez-nous à : 
                  <a href="mailto:privacy@patricians.xyz" className="text-decoration-none">
                    privacy@patricians.xyz
                  </a>
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">8. Conservation des données</h2>
                <p>
                  Nous conservons vos données personnelles aussi longtemps que nécessaire 
                  pour les finalités décrites dans cette politique, ou conformément aux 
                  obligations légales. Les données de commande sont conservées pendant 
                  10 ans pour des raisons comptables et fiscales.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">9. Transferts internationaux</h2>
                <p>
                  Vos données peuvent être transférées vers des pays situés en dehors de 
                  l'Espace économique européen. Dans ce cas, nous nous assurons que des 
                  garanties appropriées sont en place pour protéger vos données.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">10. Modifications de cette politique</h2>
                <p>
                  Nous pouvons modifier cette politique de confidentialité de temps à autre. 
                  Toute modification sera publiée sur cette page avec une nouvelle date 
                  de mise à jour. Nous vous encourageons à consulter régulièrement cette page.
                </p>
              </section>

              <section className="mb-5">
                <h2 className="h4 mb-3">11. Contact</h2>
                <p>
                  Si vous avez des questions concernant cette politique de confidentialité 
                  ou le traitement de vos données personnelles, n'hésitez pas à nous contacter :
                </p>
                <div className="bg-light p-3 rounded">
                  <p className="mb-1"><strong>Patricians</strong></p>
                  <p className="mb-1">Email : <a href="mailto:contact@patricians.xyz" className="text-decoration-none">contact@patricians.xyz</a></p>
                  <p className="mb-0">Téléphone : +33 1 23 45 67 89</p>
                </div>
              </section>

              <div className="text-center mt-5">
                <a href="/" className="btn btn-primary">
                  Back to home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
